<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card
        no-body
        class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
      >
        <b-navbar
          class="background-white"
          toggleable="lg"
        >
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand
            href="#"
            class="text-dark"
          >
            <strong>Approvals</strong>
          </b-navbar-brand>

          <b-collapse
            id="nav-collapse"
            is-nav
          >
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  v-if="!managerDashboard"
                  @click="showAddApproverModal = !showAddApproverModal"
                  class="my-2 my-sm-0 mr-2"
                  variant="outline-primary"
                  size="sm"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-2"
                  @click="reloadTable"
                >
                  <font-awesome-icon icon="sync" />
                </b-button>
                <b-form-group>
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 395px)"
          fixed
          :busy.sync="isLoading"
          ref="table"
          id="employee-gift-table"
          :fields="staticFields"
          :items="getApprovalsData"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
        >
          <template v-slot:cell(created_at)="data">{{ createdAtDate(data.item.created_at) }}</template>
          <template v-slot:cell(title)="data">
            <p
              class="link-text"
              @click="OpenDetailPage('/gifts-approval/'+data.item.id+'/2')"
            >{{data.item.title}}</p>
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.item.status == 1"
              variant="info"
            >OPEN</b-badge>
            <b-badge
              v-else-if="data.item.status == 2"
              variant="warning"
            >COMPLETED</b-badge>
            <b-badge
              v-else-if="data.item.status == 3"
              variant="danger"
            >ON-HOLD</b-badge>
            <b-badge
              v-else-if="data.item.status == 4"
              variant="success"
            >APPROVED</b-badge>
            <b-badge
              v-else-if="data.item.status == 5"
              variant="danger"
            >REJECTED</b-badge>
          </template>
        </b-table>
        <template v-slot:footer>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <p class="text-center">
                Showing Result From
                <b>{{fromRows}}</b> to
                <b>{{toRows}}</b>
              </p>
            </b-col>
            <b-col cols="4">
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                aria-controls="employee-gift-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-overlay>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Add Approval"
      size="lg"
      v-model="showAddApproverModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <!-- <b-form-group label-cols-sm="4" label-cols-lg="3" label="Currency:">
            <label class="text-left">
              <span class="required-span">*</span>
            </label>
            <b-form-input
              v-model="$v.form.currency.$model"
              :state="$v.form.currency.$dirty ? !$v.form.currency.$error : null"
              size="sm"
              disabled
            ></b-form-input>
          </b-form-group>-->
          <b-form-group
            class="mb-2"
            label-cols-sm="4"
            label-cols-lg="3"
            label="Type of Expense:"
          >
            <v-select
              label="text"
              :class="$v.form.approvalType.$error ? 'border border-danger rounded form-control-small' : 'form-control-small'"
              v-model="$v.form.approvalType.$model"
              :state="$v.form.approvalType.$dirty ? !$v.form.approvalType.$error : null"
              :options="approvalTypesOptions"
            ></v-select>
          </b-form-group>
          <b-form-group
            class="mb-2"
            label-cols-sm="4"
            label-cols-lg="3"
            label="Amount:"
          >
            <b-form-input
              size="sm"
              v-currency="{
                locale: 'en',
                currency: 'USD'
              }"
              v-model="$v.form.amount.$model"
              :state="$v.form.amount.$dirty ? !$v.form.amount.$error : null"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="mb-2"
            label-cols-sm="4"
            label-cols-lg="3"
            label="Description:"
          >
            <b-form-textarea
              size="sm"
              placeholder="Please provide brief description"
              v-model="form.description"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Approval is being Creating......</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Your Approval has been added successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="resetModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >Save</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { CurrencyDirective } from "vue-currency-input";
import { Helper } from "../../../helpers";
export default {
  name: "GiftsTab",
  mixins: [validationMixin],
  directives: {
    currency: CurrencyDirective,
  },
  data () {
    return {
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      showAddApproverModal: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      fromRows: 0,
      toRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Date Filed", sortable: true },
        { key: "title", label: "Approval Type", sortable: true },
        // { key: "currency", label: "Currency", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
      approvalTypesOptions: [],
      currenciesOptions: [],
      form: {
        approvalType: null,
        currency: "USD",
        amount: null,
        description: null,
      },
      approvalTypeId: null,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  validations: {
    form: {
      approvalType: { required },
      currency: { required },
      amount: { required },
    },
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getCurrenciesList();
    this.getApprovalTypesList();
  },
  methods: {
    OpenDetailPage ( url ) {
      this.$router.push( url );
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-gift-table" );
    },
    async getApprovalsData () {
      let employeeId = localStorage.getItem( "employeeId" );
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
        employee_id: employeeId,
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/approvals/get", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.$store.state.employeeDashboardGiftsLazyLoad = false;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    async getCurrenciesList () {
      this.currenciesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/currencies-list",
          null
        );
        this.currenciesOptions = result.data.currency;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getApprovalTypesList () {
      this.approvalTypesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/approvals/type/list", null );
        this.approvalTypesOptions = result.data.approvalTypes;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    resetForm () {
      this.form = {
        approvalType: null,
        currency: "USD",
        amount: null,
        description: null,
      };
      this.$v.$reset();
    },
    resetModal () {
      this.resetForm();
      this.approvalTypeId = null;
      this.showAddApproverModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else {
        this.saveApproval().then( this.reloadTable );
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.resetModal();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async saveApproval () {
      let employeeId = localStorage.getItem( "employeeId" );
      let formData = {
        approval_type_id: this.form.approvalType
          ? this.form.approvalType.value
          : null,
        approval_type: this.form.approvalType
          ? this.form.approvalType.text
          : null,  
        currency_id: 1,
        employee_id: employeeId,
        amount: this.form.amount,
        meta_data: {
          description: this.form.description,
        },
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/approvals/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data.status != 1 ) {
          this.makeToster( "danger", result.data.message );
        } else if ( result.data.status == 1 ) {
          this.makeToster( "success", result.data.message );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
  props: {
    managerDashboard: Boolean,
  },
};
</script>
<style scoped>
.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}
</style>